






















import { Component, Prop, Mixins } from 'vue-property-decorator';
import LayoutOptionsMixin from '@/mixins/LayoutOptionsMixin';

@Component
export default class PreviewBooleanField extends Mixins(LayoutOptionsMixin) {
  @Prop()
  readonly label!: string;

  @Prop()
  readonly value!: boolean;
}
